import { render } from "./IcedToffee.vue?vue&type=template&id=71f60f6b"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/IcedToffee.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71f60f6b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71f60f6b', __exports__)) {
    api.reload('71f60f6b', __exports__)
  }
  
  module.hot.accept("./IcedToffee.vue?vue&type=template&id=71f60f6b", () => {
    api.rerender('71f60f6b', render)
  })

}


export default __exports__